import ReactDOM from 'react-dom';
import React from 'react';

import { IModalAlertParams } from './interface';
import CommonModal from './commonModal';

// eslint-disable-next-line import/no-cycle
import Modal from './index';

class Alert extends CommonModal<IModalAlertParams> {
  render(visible: boolean, options: IModalAlertParams): void {
    const { title, onOk, onClose, content, okProps, okText = '确定', closable = true, ...restProps } = options;
    ReactDOM.render(
      <Modal
        visible={visible}
        title={title}
        closable={closable}
        footers={[
          {
            content: okText,
            type: 'primary',
            onClick: (): void => {
              this.render(false, options);
              onOk?.();
            },
            ...okProps,
          },
        ]}
        onClose={(): void => {
          this.destroy();
          onClose?.();
        }}
        {...restProps}
      >
        {content}
      </Modal>,
      this.modalContainer,
    );
  }
}

export default Alert;
